import AdvancedController from "./advanced-controller"
import { Breakpoints } from "../utils/breakpoints";


const NAV_TOGGLE_BREAKPOINT = 'lg'
export default class HeaderController extends AdvancedController {



    static values = {
        isNavToggled: Boolean,
        isSearchToggled: Boolean,
        windowWidth: Number,
    }

    static targets = [
        "navToggle",
        "searchForm",
        "searchField",
        "searchToggleButton"
    ]

    connect() {
        super.connect();
        this.navMainTarget = document.getElementById('nav-main');
        this.breakpoints = new Breakpoints();
        // outside click close
        window.addEventListener('click', (e) => {
            if (this.isSearchToggledValue && !this.searchFormTarget.contains(e.target) && !this.searchToggleButtonTarget.contains(e.target)) {
                this.isSearchToggledValue = false
                this._handleState();
            }
        })
        this.resize();
    }


    resize() {

        if (this.breakpoints.breakpointUp(NAV_TOGGLE_BREAKPOINT)) {
            this.navMainTarget.classList.add('nav-desktop');
        } else {
            this.navMainTarget.classList.remove('nav-desktop');
        }
    }

    onToggleClick(e) {
        e.preventDefault();
        this.isNavToggledValue = !this.isNavToggledValue;
        if (this.isNavToggledValue) this.isSearchToggledValue = false
        this._handleState();
    }

    onSearchToggle(e) {
        e.preventDefault();
        this.isSearchToggledValue = !this.isSearchToggledValue;
        if (this.isSearchToggledValue) this.isNavToggledValue = false
        this._handleState();
    }

    _handleClasses() {
        this.element.classList.toggle('-nav-toggled', this.isNavToggledValue)
        this.element.classList.toggle('-search-toggled', this.isSearchToggledValue)
    }

    _handleState() {
        this._handleClasses();

        if (this.isNavToggledValue) {
            this.navMainTarget.style.display = "flex"
        } else {
            this.navMainTarget.style.display = "none"
        }
        if (this.hasSearchFormTarget) {
            if (this.isSearchToggledValue) {
                this.searchFormTarget.style.display = "flex"
                this.searchFieldTarget.focus()
            } else {
                this.searchFormTarget.style.display = "none"
            }
        }
    }

    messageCloseNav() {
        for (const controller of this.getAllControllers("nav-main-sub-menu")) {
            controller.messageClose();
        }
        this.isNavToggledValue = false
        this._handleState();
    }

}